import { 
  Box, 
  Button, 
  Checkbox, 
  FormControl, 
  FormControlLabel, 
  FormGroup, 
  FormHelperText, 
  MenuItem, 
  Modal, 
  Select, 
  Stack, 
  TextField, 
  Typography 
} from "@mui/material";
import { ClientData, ClientDataError, SectorData } from "../../types";
import { useEffect, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { ConfirmDialog } from "../../components/global/ConfirmDialog";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";

interface ClientModalProps {
  open: boolean;
  handleClose:() => void;
  handleSave:() => void;
  client: ClientData;
  sectors: SectorData[];
}

export const ClientModal = ({open, handleClose, handleSave, client, sectors}: ClientModalProps) => {
  const [mClient, setMClient] = useState<ClientData>(client);
  const [error, setError] = useState<ClientDataError>({});
  const { fetchData } = useAPI();
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  useEffect(() => {
    setMClient({ ...client});
  }, [client]);

  const onSaveClient = async (client: ClientData) => {
    const {errors, data} = await fetchData('/clients/save',  client, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  const onDeleteClient = async (client: ClientData) => {
    const {errors, data} = await fetchData('/clients/delete',  { id: client.id }, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
        maxHeight: '90%',
        overflow: 'auto',
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600">
          { client.id ? "Edit Client" : "Add Client" }
        </Typography>
        <Stack mt={4} spacing={4}>
          <FormGroup>
            <Typography fontWeight="600">Name</Typography>
            <TextField
              variant="outlined"
              value={mClient.name}
              error={error.name ? true : false}
              helperText={error?.name?.[0] ?? ''}
              onChange={(e) => setMClient({ ...mClient, name: e.target.value })}
              sx={{ width: '100%' }}
            />
          </FormGroup>
          <FormGroup>
            <FormControl error={error.sector_id ? true : false}>
              <Typography fontWeight="600">Sector</Typography>
              <Select
                variant="outlined"
                value={mClient.sector_id ?? ''}
                onChange={(e) => setMClient({ ...mClient, sector_id: e.target.value })}
                sx={{ width: '100%' }}
              >
                {
                  sectors.map((item: any) => (
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))
                }
              </Select>
              {
                error.sector_id ? (
                  <FormHelperText color="#ff1744" style={{ marginBottom: "-20px" }}>
                    {error?.sector_id?.[0] ?? ''}
                  </FormHelperText>
                ) : null
              }
            </FormControl>
          </FormGroup>
          <FormGroup>
            <Typography fontWeight="600">Client Account Number</Typography>
            <TextField
              variant="outlined"
              value={mClient.account_number}
              error={error.account_number ? true : false}
              helperText={error?.account_number?.[0] ?? ''}
              onChange={(e) => setMClient({ ...mClient, account_number: e.target.value })}
              sx={{ width: '100%' }}
            />
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={0} sx={{ width: '100%' }}>
              <Box sx={{ width:  '40%' }}>
                <FormControlLabel 
                  sx={{ width: '100%' }} 
                  control={<Checkbox />} 
                  value={true}
                  label="Client Active" 
                  checked={mClient.status ? true : false}
                  onChange={(e, status) => setMClient({ ...mClient, status: status })}
                />
              </Box>
            </Stack>
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={2}>
              <Button variant="contained" size="large" onClick={() => onSaveClient(mClient)}>
                Save Client
              </Button>
              {
                client.id && (
                  <Button variant="outlined" size="large" color="error" onClick={() => 
                    openDialog(
                      "Confirm Deletion",
                      `Are you sure you want to delete the client "${mClient.name}"?`,
                      () => onDeleteClient(mClient)
                    )
                  }>
                    Delete Client
                  </Button>
                )
              }
              <Button variant="text" size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Stack>
          </FormGroup>
        </Stack>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}